import React from "react";
import { Crown } from "lucide-react";
import { ROLE_BADGE_STYLES, DEFAULT_ROLE_BADGE_STYLE, BRAND_ROLE } from "utils/user-identity";

// Uppercase role pill shown next to a user's name. Pair it with
// getDisplayIdentity() so the role it renders is the *display* role
// (SUPER_ADMIN presents as FOUNDER), not the raw one from the API.
const SIZES = {
  sm: "px-1.5 py-0.5 text-[8.5px]",
  md: "px-1.5 py-0.5 text-[9px]",
};

const RoleBadge = ({ role, size = "md", className = "" }) => {
  if (!role) return null;

  return (
    <span
      className={`inline-flex items-center gap-1 flex-shrink-0 rounded font-bold uppercase tracking-wide ${
        SIZES[size] || SIZES.md
      } ${ROLE_BADGE_STYLES[role] || DEFAULT_ROLE_BADGE_STYLE} ${className}`}
    >
      {role === BRAND_ROLE && <Crown size={9} className="fill-current" />}
      {role}
    </span>
  );
};

export default RoleBadge;
